
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/linkme.php",
      function () {
        return require("private-next-pages/linkme.php.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/linkme.php"])
      });
    }
  